import { Breakpoints, PrimaryColors } from '@/common/theme/constants';
import { SxProps } from '@mui/material';

export const acconrdionWrapperStyles: SxProps = {
  backgroundColor: 'transparent',
  boxShadow: 'none',
  '&:before': { display: 'none' },
};

export const accordionSummaryStyles: SxProps = {
  p: 0,
  [`@media (max-width:${Breakpoints.sm}px)`]: {
    minHeight: 'unset',

    '& .MuiAccordionSummary-content': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
};

export const styledSectionTitle: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  pr: '11px',
  color: PrimaryColors.black,
  textTransform: 'uppercase',
};

export const styledAccordionDetails: SxProps = {
  color: PrimaryColors.black,
  px: 0,
  pt: '1rem',
  pb: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  [`@media (min-width:${Breakpoints.md}px)`]: {
    py: '1rem',
  },
};
